import React from 'react';
import { createStyles, makeStyles, Typography } from '@material-ui/core';
import colors from '../../../../../themes/main-colors';

const useStyles = makeStyles(() =>
  createStyles({
    circle: {
      display: 'inline-flex',
      height: '2rem',
      width: '2rem',
      justifyContent: 'center',
      alignItems: 'center',
      color: colors.errorRed,
      background: colors.white,
      border: `3px solid ${colors.errorRed}`,
      borderRadius: '100%',
      fontSize: '0.75rem',
    },
  }),
);

interface Props {
  outageCount: number | null;
}

export const OutageCountCircleIcon = (props: Props) => {
  const classes = useStyles();
  const outageCount = props.outageCount
    ? props.outageCount > 999
      ? '1K+'
      : props.outageCount > 99
      ? '99+'
      : props.outageCount.toString()
    : null;

  return (
    <Typography
      className={classes.circle}
      component="div"
      data-testid="OutageCountCircleIcon"
    >
      {outageCount}
    </Typography>
  );
};

export default OutageCountCircleIcon;
